import { useState } from 'react'

import { Button, Checkbox, TablePagination } from '@material-ui/core'
import SetState from 'Components/Hooks/SetState'
import BasicTable from 'Components/UI/Atoms/BasicTable'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { interfaces } from 'service/interfaces'

const CheckList = (props) => {
  const { addProducts, checkElement, setCheckElement, type } = props

  const [loading, setLoading] = useState(true)
  const [listParts, setListParts] = useState([])

  const { state, setClose, setOpen } = SetState()
  const [count, setCount] = useState(0)
  const [currentPage, setCurrentPage] = useState(0)

  const handleChangeCheckElement = (id) => {
    const selectedPart = listParts.find((part) => part.id === id)

    if (!checkElement.some((item) => item.id === selectedPart.id)) {
      setCheckElement([...checkElement, selectedPart])
    } else {
      setCheckElement(checkElement.filter((item) => item.id !== selectedPart.id))
    }
  }

  async function apiCall() {
    const options = `?limit=25&offset=0&orderby=id&order=desc&estado=1&empresa=1`
    type === 49
      ? await interfaces.accounting.listOwnChecks(options).then((res) => {
          setListParts(res.data)
          setCount(res.header.header.count)
        })
      : await interfaces.accounting.listThirPartyChecks(options).then((res) => {
          setListParts(res.data)
          setCount(res.header.header.count)
        })
  }

  async function datesApiCall(currentPage) {
    const options = `?limit=25&offset=${currentPage}&orderby=id&order=desc&estado=1&empresa=1`
    type === 49
      ? await interfaces.accounting.listOwnChecks(options).then((res) => {
          setListParts(res.data)
          setCount(res.header.header.count)
        })
      : await interfaces.accounting.listThirPartyChecks(options).then((res) => {
          setListParts(res.data)
          setCount(res.header.header.count)
        })
  }

  async function handleOpen() {
    setCurrentPage(0)
    await apiCall()
    setLoading(false)
    setOpen()
  }

  const handleChangePage = async (event, newPage) => {
    setCurrentPage(newPage)
    await datesApiCall(newPage)
  }

  return (
    <div>
      <Button color="primary" variant="outlined" onClick={handleOpen}>
        AGREGAR
      </Button>

      {loading ? (
        ''
      ) : (
        <DialogComponent
          tipo="center"
          open={state.open}
          handleclose={setClose}
          title="Añadir ítem de orden de pago"
          subtitle={type === 49 ? 'Cheques propios' : 'Cheques de terceros'}
          widthLarge="800px"
          maxHeight
          children={
            <>
              <BasicTable
                col={[
                  { title: '', style: { width: '40px' } },
                  { title: 'Banco', style: { width: '80px' } },
                  { title: 'Nº de cheque', style: { width: '80px' } },
                  { title: 'Vencimiento', style: { width: '80px' } },
                  { title: 'Importe', style: { width: '80px' } },
                ]}
                size="small"
                rows={listParts.map((row) => {
                  const isDisabled = row.pago_id !== null
                  return {
                    seleccionar: (
                      <Checkbox
                        onChange={() => handleChangeCheckElement(row.id)}
                        checked={checkElement.some((item) => item.id === row.id)}
                        disabled={isDisabled}
                      />
                    ),
                    banco: row.banco,
                    nro_cheque: row.nro_cheque,
                    vencimiento: row.egreso, ///no se que prop corresponde a vencimiento
                    importe: row.importe,
                  }
                })}
              ></BasicTable>
              <TablePagination
                rowsPerPageOptions={[]}
                component="div"
                count={count}
                rowsPerPage={10}
                page={currentPage}
                onPageChange={handleChangePage}
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
              />
            </>
          }
          actions={
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
                marginRight: '15px',
              }}
            >
              <Button onClick={setClose}>Cancelar</Button>
              <Button
                onClick={addProducts}
                color="primary"
                variant="contained"
                disabled={checkElement.length === 0}
              >
                Seleccionar
              </Button>
            </div>
          }
        />
      )}
    </div>
  )
}

export default CheckList
